import { render, staticRenderFns } from "./Formats.vue?vue&type=template&id=ffde13b0&"
import script from "./Formats.vue?vue&type=script&lang=js&"
export * from "./Formats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports